var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-export-1179554",
    transform: "translate(-20 -20.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1860",
    "data-name": "Raggruppa 1860",
    transform: "translate(20 20.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_42",
    "data-name": "Tracciato 42",
    d: "M31.329,39.777a1.047,1.047,0,0,0,1.306,1.084s-.392.111.048-.013a10,10,0,1,0-5.344.006c.433.121.026.007.026.007a1.052,1.052,0,0,0,1.306-1.084V31.29c0-.187-.105-.232-.236-.1,0,0-1.078,1.1-1.465,1.5a1.341,1.341,0,1,1-1.891-1.9l4.07-4.114a1.17,1.17,0,0,1,1.658,0l4.113,4.119A1.341,1.341,0,0,1,33.041,32.7c-.4-.411-1.476-1.509-1.476-1.509-.131-.133-.236-.089-.236.1Z",
    transform: "translate(-20 -20.91)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.4df902f8b9d03cbbd3c9c5cfbbe4c19b.svg";
export { ForwardRef as ReactComponent };